import SetupTHead from "../../../common/theads/SetupTHead";
import { updatePackageTHeadData } from "../../../../data/admin-data";
import UpdatePackageItemTBody from "../../../common/tbody/UpdatePackageItemTBody";

interface NewPackageSelectedItemsProps {
    typOfAction: "newPackage" | "updatePackage"
}


export default function NewPackageSelectedItems({ typOfAction }: NewPackageSelectedItemsProps) {

    
    return (
        <div className='h-full overflow-hidden bg-white rounded border'>
            <div className='overflow-y-auto h-full'>
                <table className='min-w-max w-full'>
                    <SetupTHead data={updatePackageTHeadData}/>
                    <UpdatePackageItemTBody typOfAction={typOfAction}/>
                </table>
            </div>
        </div>
    )
}
